import { registerAtaComponents, execAtaComponent } from './glob';
import { Item } from './item';
import { List } from './list/index';
registerAtaComponents('@list', List);
registerAtaComponents('@item', Item);
export { Item, List, registerAtaComponents, execAtaComponent };